import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { ItemLinha } from '../item-linha';

@Injectable({
    providedIn: 'root'
})
export class ItemLinhaCrudHttpService implements Crud<ItemLinha> {
    resource = 'itemlinha';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todos os itens linhas cadastrados */
    search(): Observable<ItemLinha[]> {
        return this.crudService.search<ItemLinha>(this.resource);
    }

    /** Procura um único item linha através do seu ID */
    find(id: number): Observable<ItemLinha> {
        return this.crudService.find<ItemLinha>(this.resource, id);
    }

    /** Carrega um único item linha através do seu ID */
    load(id: number): Observable<ItemLinha> {
        return this.crudService.load<ItemLinha>(this.resource, id);
    }

    /** Insere um novo item linha */
    insert(entity: ItemLinha): Observable<ItemLinha> {
        return this.crudService.insert<ItemLinha>(this.resource, entity);
    }

    /** Altera um item linha existente */
    update(entity: ItemLinha): Observable<ItemLinha> {
        return this.crudService.update<ItemLinha>(this.resource, entity);
    }

    /** Exclui um item linha através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
